import React from "react"
import { CountdownTimer } from "components"
import { withDynamicComponents } from "higher-order-components"
import WysiwygContent from "components/wysiwyg-content/index.jsx"

const CountdownTimerBlock = props => <CountdownTimer {...props} />

export default withDynamicComponents({
  componentWhitelist: [WysiwygContent]
})(CountdownTimerBlock)



// WEBPACK FOOTER //
// ./src/blocks/countdown-timer/index.jsx